import { CRUD, CrudModel } from '../../classes'
import { DocumentTypeData } from './document-type.data'

@CRUD({
  base: '/crud/document-types',
})
export class DocumentTypeModel extends CrudModel {
  public id!: string
  public label!: string
  public uploadTo: string
  public uploadFileName: string

  constructor(data: DocumentTypeData) {
    super(data, true)
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      id: this.id,
      label: this.label,
      uploadTo: this.uploadTo,
      uploadFileName: this.uploadFileName,
    }
  }
}
